import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import PaymentIcon from "@mui/icons-material/Payment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { AnimatePresence, motion } from "framer-motion";
import { CompactPaymentButtonStyled } from "../../../styled/pos/windows11";
import { setShowPaymentForm } from "../../../../store/actions/newOrderSlice";

const CompactPaymentButton = ({ onCreateOrder, containerRef, onValidationFail }) => {
  const dispatch = useDispatch();

  const cartProducts = useSelector((state) => state.newOrder.cartProducts);
  const customer = useSelector((state) => state.newOrder.customer);
  const orderType = useSelector((state) => state.newOrder.orderType);
  const address = useSelector((state) => state.newOrder.address);
  const showPaymentForm = useSelector((state) => state.newOrder.showPaymentForm);
  const newOrderTable = useSelector((state) => state.orders.newOrderTable);
  const isTableOrder = orderType === "INDOOR" || !!newOrderTable;

  const hasItems = cartProducts?.length > 0;

  const isReady =
    showPaymentForm ||
    (hasItems &&
      (isTableOrder ||
        (customer && orderType && (orderType !== "DELIVERY" || address))));

  const handlePaymentClick = () => {
    dispatch(setShowPaymentForm(true));
  };

  const handleCreateOrder = () => {
    if (onCreateOrder) onCreateOrder();
  };

  return (
    <AnimatePresence>
      {isReady && (
        <motion.div
          initial={{ opacity: 0, y: -6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.22, ease: "easeOut" }}
          style={{ width: "100%" }}
        >
          {showPaymentForm ? (
            <CompactPaymentButtonStyled
              ref={containerRef}
              variant="create"
              onClick={handleCreateOrder}
              aria-label="Criar pedido"
            >
              <CheckCircleIcon sx={{ fontSize: "1.25rem" }} />
              <Typography variant="button" component="span">
                Pronto
              </Typography>
            </CompactPaymentButtonStyled>
          ) : (
            <CompactPaymentButtonStyled
              ref={containerRef}
              variant="payment"
              onClick={handlePaymentClick}
              aria-label="Ir para pagamento"
            >
              <PaymentIcon sx={{ fontSize: "1.25rem" }} />
              <Typography variant="button" component="span">
                {isTableOrder ? "Abrir Mesa" : "Finalizar Pedido"}
              </Typography>
            </CompactPaymentButtonStyled>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CompactPaymentButton;
